import { type ComponentProps, forwardRef, useCallback } from 'react';
import Animated from 'react-native-reanimated';

import type { ScrollspyV2ScrollViewRef } from '../../useScrollspyV2';

// ─────────────────────────────────────────────────────────────────────────────

export const ScrollspyV2ScrollView = forwardRef<Animated.ScrollView, ScrollspyV2ScrollViewProps>(
  (props, ref) => {
    const { children, onContentSizeChange, ...scrollViewProps } = props;

    // ─── Handlers ──────────────────────────────────────────────────────────

    const handleContentSizeChange = useCallback(
      (width: number, height: number) => {
        if (typeof onContentSizeChange === 'function') {
          onContentSizeChange(width, height);
        }
      },
      [onContentSizeChange],
    );

    // ─────────────────────────────────────────────────────────────────────

    return (
      <Animated.ScrollView
        ref={ref as ScrollspyV2ScrollViewRef}
        scrollEventThrottle={16}
        onContentSizeChange={handleContentSizeChange}
        {...scrollViewProps}
      >
        {children}
      </Animated.ScrollView>
    );
  },
);

ScrollspyV2ScrollView.displayName = 'ScrollspyV2ScrollView';

// ─── Types ───────────────────────────────────────────────────────────────────

type ScrollspyV2ScrollViewProps = Omit<
  ComponentProps<typeof Animated.ScrollView>,
  'ref' | 'horizontal'
>;
